import React from 'react'
import UpdateInfo from './UpdateInfo'

const FooterMobile = (props) => {
  return (
   <div className="footer-mobile">
       <UpdateInfo/>
   </div>
  )
}

export default FooterMobile


// WEBPACK FOOTER //
// ./src/FooterMobile.js